import { urls } from '@sendible/common';
import { MutationMethodEnum } from './types';

const { baseUrl, twBaseUrl } = urls;

export default {
  // Queries
  GetCalendar: {
    endpoint: `${twBaseUrl}/v1.0/messages`,
    interval: 30000, // 30 seconds
    cacheTime: 30000, // 30 seconds
  },
  GetCalendarSummary: {
    endpoint: `${twBaseUrl}/v1.0/messages/summary`,
    interval: 30000, // 30 seconds
    cacheTime: 30000, // 30 seconds
  },
  GetCalendarMessage: {
    endpoint: `${twBaseUrl}/v1.0/messages`,
  },
  GetMediaThumbnail: {
    endpoint: `${twBaseUrl}/v1.0/media`,
  },
  GetHolidays: {
    endpoint: `${twBaseUrl}/v1.0/holidays`,
    interval: 600000, // 10 minutes
    cacheTime: 600000, // 10 minutes
  },
  GetMediaLibraries: {
    endpoint: `${baseUrl}/0.1/tw/media_libraries`,
    interval: 600000, // 10 minutes
  },
  GetMedias: {
    endpoint: `${baseUrl}/0.2/tw/media`,
    interval: 300000, // 5 minutes
  },
  GetMedia: {
    endpoint: `${baseUrl}/0.2/tw/media`,
    interval: 1000,
  },
  GetFilters: {
    endpoint: `${twBaseUrl}/v1.0/filters`,
  },
  GetQueues: {
    endpoint: `${baseUrl}/1.0/api/queues`,
    interval: 30000,
    cacheTime: 30000,
  },
  GetTogglableFeatures: {
    endpoint: `${twBaseUrl}/v1.0/features/toggles`,
  },
  RequestWorkspaceAccess: {
    endpoint: `${twBaseUrl}/v1.0/workspace-access-requests`,
    method: MutationMethodEnum.post,
  },
  // Giphy, Pexels
  GetMediaSearch: {
    endpoint: `${baseUrl}/api/v3/images/search/`,
  },
  GetFlickrSearch: {
    endpoint: 'https://api.flickr.com/services/rest/',
  },
  GetLinkPreview: {
    endpoint: `${baseUrl}/api/v0/linkpreview.json`,
  },
  GetRecentMedias: {
    endpoint: `${baseUrl}/api/v2/media.json`,
  },
  GetUsers: {
    endpoint: `${baseUrl}/api/v0/users.json`,
  },
  // Mutations
  CreateMedia: {
    endpoint: `${baseUrl}/0.2/tw/media`,
    method: MutationMethodEnum.post,
  },
  CreateMediaLibrary: {
    endpoint: `${baseUrl}/0.1/tw/media_libraries`,
    method: MutationMethodEnum.post,
  },
  RenameMediaLibrary: {
    endpoint: `${baseUrl}/0.1/tw/media_libraries`,
    method: MutationMethodEnum.put,
  },
  DeleteMediaLibrary: {
    endpoint: `${baseUrl}/0.1/tw/media_libraries`,
    method: MutationMethodEnum.delete,
  },
  UploadMedias: {
    endpoint: `${baseUrl}/0.2/tw/uploads`,
    method: MutationMethodEnum.post,
  },
  DeleteMedia: {
    endpoint: `${baseUrl}/0.2/tw/media`,
    method: MutationMethodEnum.delete,
  },
  RenameMedia: {
    endpoint: `${baseUrl}/0.2/tw/media`,
    method: MutationMethodEnum.put,
  },
  CompleteUploadMedias: {
    endpoint: `${baseUrl}/0.2/tw/uploads`,
    method: MutationMethodEnum.put,
  },
  AbortUploadMedias: {
    endpoint: `${baseUrl}/0.2/tw/uploads`,
    method: MutationMethodEnum.delete,
  },
  RescheduleMessage: {
    endpoint: `${twBaseUrl}/v1.0/messages`,
    method: MutationMethodEnum.post,
  },
  ResolveRecipients: {
    endpoint: `${twBaseUrl}/v1.0/messages`,
    method: MutationMethodEnum.post,
  },
  DeleteMessage: {
    endpoint: `${baseUrl}/2.0/api/message`,
    method: MutationMethodEnum.delete,
  },
  EnableFeatureTag: {
    endpoint: `${baseUrl}/api/v2/features`,
    method: MutationMethodEnum.post,
  },
  DisableFeatureTag: {
    endpoint: `${baseUrl}/api/v2/features`,
    method: MutationMethodEnum.delete,
  },
} as const;
